import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Button } from "reactstrap";
import { Helmet } from "react-helmet";
import Spinner from "../../Spinner/spinner";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import ModalCreate from "./ModalCreate";
import ModalEdit from "./ModalEdit";
import { localeEs } from "../../locale/ag-grid-es";
import withTokenCheck from "../../withTokenCheck";

const AppPaciente = ({ token }) => {
    const [acompanante, setAcompanante] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalEditOpen, setModalEditOpen] = useState(false);
    const [modalContent, setModalContent] = useState({});
    const [modalEditcontent, setModalEditContent] = useState({});
    const [, setModalTittleContent] = useState({});
    const gridApi = useRef(null);

    useEffect(() => {
        if (token) {
            axios
                .get("/acompanante", {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    setAcompanante(response.data);
                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [token]);

    const defaultColDef = {
        sortable: true,
        resizable: true,
        filter: true,
        editable: true,
    };

    const columnDefs = [
        { headerName: "Tipo Acompañante", field: "tipo_acompanante.Texto" },
        { headerName: "Paciente Relacionado", field: "paciente.Nombre" },
        { headerName: "Primer Nombre", field: "Nombre1" },
        { headerName: "Segundo Nombre", field: "Nombre2" },
        { headerName: "Primer Apellido", field: "Apellido1" },
        { headerName: "Segundo Apellido", field: "Apellido2" },
        { headerName: "Tipo Documento", field: "tipo_documento.Texto" },
        { headerName: "Numero de Identificación", field: "NumeroIdent" },
        { headerName: "Fecha Nacimiento", field: "FechaNacimiento" },
        {
            headerName: "Editar",
            cellRenderer: (params) => (
                <Button
                    color="secondary"
                    onClick={() => handleEditClick(params.data)}
                >
                    Editar
                </Button>
            ),
        },
    ];

    const handleModalToggle = () => setModalOpen(!modalOpen);
    const handleEditModalToggle = () => setModalEditOpen(!modalEditOpen);

    const handleButtonClick = () => {
        setModalContent({
            title: "Vincular Acompañante",
            footer: (
                <Button
                    className="mb-3"
                    color="secondary"
                    onClick={handleModalToggle}
                >
                    Cancelar
                </Button>
            ),
        });
        handleModalToggle();
    };

    const handleEditClick = (element) => {
        setModalEditContent(element);
        setModalTittleContent({
            title: "Actualizar Acompañante",
            footer: (
                <Button
                    className="mb-3"
                    color="secondary"
                    onClick={handleEditModalToggle}
                >
                    Cancelar
                </Button>
            ),
        });
        handleEditModalToggle();
    };

    const handleExportCSV = () => {
        gridApi.current.exportDataAsCsv();
    };

    const onGridReady = (params) => {
        gridApi.current = params.api;
    };

    const handleUpdateTable = () => {
        setLoading(true);
        if (token) {
            axios
                .get("/acompanante", {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    setAcompanante(response.data);
                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    return (
        <>
            <Helmet>
                <title>Acompañante</title>
            </Helmet>
            <div style={{ position: "relative" }}>
                {loading && <Spinner />}
                <div style={{ opacity: loading ? 0.5 : 1 }}>
                    <div className="container-fluid mt-5">
                        <Button color="primary" onClick={handleButtonClick}>
                            Vincular Acompañante
                        </Button>
                        <Button color="success" onClick={handleExportCSV}>
                            Exportar CSV (Excel)
                        </Button>
                        <div
                            className="mt-3"
                            style={{ height: "500px", width: "100%" }}
                        >
                            <div
                                className="ag-theme-alpine"
                                style={{ height: "100%", width: "100%" }}
                            >
                                <AgGridReact
                                    rowData={acompanante}
                                    columnDefs={columnDefs}
                                    defaultColDef={defaultColDef}
                                    pagination={true}
                                    onGridReady={onGridReady}
                                    localeText={localeEs}
                                    paginationPageSize={20}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ModalCreate
                isOpen={modalOpen}
                toggle={handleModalToggle}
                title={modalContent.title}
                content={modalContent.content}
                footer={modalContent.footer}
                token={token}
                updateTable={handleUpdateTable}
            />
            <ModalEdit
                isOpen={modalEditOpen}
                toggle={handleEditModalToggle}
                modalContent={modalEditcontent}
                footer={modalEditcontent.footer}
                token={token}
                updateTable={handleUpdateTable}
            />
        </>
    );
};

export default withTokenCheck(AppPaciente);
